import React from "react";
import styles from "./GalleryAmigurumis.module.css";
import chenille0 from "../data/assets/Amigurumis/Ballena/0.png";
import chenille1 from "../data/assets/Amigurumis/Ballena/3.png";
import chenille2 from "../data/assets/Amigurumis/Conejo/0.png";
import chenille3 from "../data/assets/Amigurumis/Gato/Gato M/0.png";
import chenille4 from "../data/assets/Amigurumis/Hongo/0.png";
import chenille5 from "../data/assets/Amigurumis/Hongo/1.png";
import chenille6 from "../data/assets/Amigurumis/plush/abeja-1.png";
import chenille7 from "../data/assets/Amigurumis/plush/sol-2.png";
import chenille8 from "../data/assets/Amigurumis/plush/rana-2.png";
import chenille14 from "../data/assets/Amigurumis/Gato/Gato S/0.png";
import chenille9 from "../data/assets/Amigurumis/Gato/Gato S/1.png";
import chenille10 from "../data/assets/Amigurumis/Gato/Gato S/2.png";
import chenille11 from "../data/assets/Amigurumis/Gato/Gato S/3.png";
import chenille12 from "../data/assets/Amigurumis/Gato/Gato S/4.png";
import chenille13 from "../data/assets/Amigurumis/Gato/Gato S/5.png";

function GalleryChenille() {
  const data = [
    chenille11,
    chenille8,
    chenille4,
    chenille3,
    chenille0,
    chenille10,
    chenille6,
    chenille9,
    chenille13,
    chenille2,
    chenille5,
    chenille12,
    chenille7,
    chenille1,
    chenille14,
  ];
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Amigurumis extra suavecitos</h2>
      <div className={styles.gallery}>
        {data.map((item, i) => (
          <figure className={styles.item} key={i}>
            <img src={item} alt="foto" className={styles.image}></img>
          </figure>
        ))}{" "}
      </div>
    </div>
  );
}

export { GalleryChenille };
